import { render, staticRenderFns } from "./BchOrderDetailDrawer.vue?vue&type=template&id=76e0654a&scoped=true"
import script from "./BchOrderDetailDrawer.vue?vue&type=script&lang=js"
export * from "./BchOrderDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./BchOrderDetailDrawer.vue?vue&type=style&index=0&id=76e0654a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e0654a",
  null
  
)

export default component.exports